import { Heading } from "@trueskin-web/components"

import ProductCards from "../../components/product-cards/product-cards"

const Products = () => (
  <>
    <Heading as="h3" size="sm" sx={{ mt: 6, mb: 4, fontWeight: "bold" }}>
      In Deinem Behandlungsplan enthalten
    </Heading>

    <ProductCards />
  </>
)

export default Products
